/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {WGGameAssets} from "../WGGameAssets";
import {WGIntroSlideShowPage} from "./WGIntroSlideShowPage";
import {WarriorGraveyard} from "../WarriorGraveyard";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class WGIntroConfig implements GameIntroViewConfig {
    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0.4, //Default 0.4
            bulletColor: 0xffffff //Default 0xffffff
        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        xWays: false,
        xNudge: true,
        volatility: Volatility.HIGH
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("feature1", "resources/images/Intro_feature1.png");
        imgLoader.add("feature2", "resources/images/Intro_feature2.png");
        imgLoader.add("feature2_US", "nolimit/screens/images/pageImage_2_US.png");
        imgLoader.add("feature3", "resources/images/Intro_feature3.png");
        imgLoader.add("feature3_US", "nolimit/screens/images/pageImage_3_US.png");
        imgLoader.add("feature4", "resources/images/Intro_feature4.png");
        imgLoader.add("feature4_US", "nolimit/screens/images/pageImage_4_US.png");
        imgLoader.add("logo", "resources/images/introLogo.png");
        imgLoader.add(WGGameAssets.WIN_AMOUNT_SHADOW, WGGameAssets.WIN_AMOUNT_SHADOW); //Not actually needed for into, but was included in that spitesheet so it needs to be loaded.
        imgLoader.add(WGGameAssets.BG_LEFT_PILLAR, WGGameAssets.BG_LEFT_PILLAR); //Not actually needed for into, but was included in that spitesheet so it needs to be loaded.
        imgLoader.add(WGGameAssets.BG_RIGHT_PILLAR, WGGameAssets.BG_RIGHT_PILLAR); //Not actually needed for into, but was included in that spitesheet so it needs to be loaded.

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);

        if (WarriorGraveyard.api.gameClientConfiguration.isSet) {
            this.loadUSImages();
        } else {
            WarriorGraveyard.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.loadUSImages();
            });
        }
    }

    private loadUSImages(): void {
        if (!WarriorGraveyard.api.gameClientConfiguration.showMultipliersInfo) {
            this.pages = [
                new WGIntroSlideShowPage([ImgLoader.getImgTexture("feature1"), ImgLoader.getImgTexture("feature2_US")], [1, 1]),
                new WGIntroSlideShowPage([ImgLoader.getImgTexture("feature3_US"), ImgLoader.getImgTexture("feature4_US")], [1, 1])
            ];
        } else {
            this.pages = [
                new WGIntroSlideShowPage([ImgLoader.getImgTexture("feature1"), ImgLoader.getImgTexture("feature2")], [1, 1]),
                new WGIntroSlideShowPage([ImgLoader.getImgTexture("feature3"), ImgLoader.getImgTexture("feature4")], [1, 1])
            ];
        }
    }
}